import axios from "axios";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { NotificationManager } from "react-notifications";
import Modal from "../../../components/Modal/Modal";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
const initialData = {
    fell_out_of_contract: "",

};

const FellOutContract = ({ showModal, onClose, onCallApi, id }) => {
    const [config] = useAuth();
    const [disable, setDisable] = useState(false);
    const [error, setError] = useState();
    const [formData, setFormData] = useState(initialData);


    const handleChange = (value, name) => {
        setError({ ...error, [name]: "" });
        setFormData({ ...formData, [name]: value });
    };

    const handleClose = () => {
        setFormData(initialData);
        onClose();
        setError();
    };


    const handleUpdateStatus = (e) => {
        e.preventDefault();
        setDisable(true);

        const dataToSend = {
            fell_out_of_contract: formData?.fell_out_of_contract,
        };

        axios
            .post(`${BASE_URL}/fell-out-of-contract/${id}`, dataToSend, config)
            .then((res) => {
                onCallApi();
                onClose();
                if (res?.data?.message) {
                    NotificationManager.success(res?.data?.message);
                }
            })
            .catch((err) => {
                if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                    NotificationManager.error(err.response?.data?.message);
                }
            });
    };

    useEffect(() => {
        if (showModal) {
            setFormData(initialData);
            setError({});
            setDisable(false);
        }
    }, [showModal]);

    return (
        <Modal title={"Convert To  Fell Out Of Contract"} desc={`Add the  Fell Out Of Contract Information`} show={showModal} onClose={onClose}>
            <form onSubmit={handleUpdateStatus}>

                <div className="mt-6">
                    <label className="dark-H head-4 mb-2 required:*:">
                        Fell Out Of Contract <span className="red-D">*</span>
                    </label>
                    <DatePicker
                        className="body-N"
                        dateFormat="MM/dd/yyyy"
                        placeholderText="MM/DD/YYYY"
                        selected={formData.fell_out_of_contract}
                        onChange={(date) => {
                            handleChange(date, "fell_out_of_contract");
                        }}
                    />
                    {error?.fell_out_of_contract && <span className="body-S red-D">{error?.fell_out_of_contract}</span>}
                </div>


                <div className="mt-7">
                    <button type="submit" className="save-button light-L head-5 green-bg-H">
                        Save
                    </button>
                    <button type="button" onClick={handleClose} className="green-H ml-5">
                        Cancel
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default FellOutContract;
